import cls from "@fvilers/cls";
import { isString } from "radashi";
import { ReactNode } from "react";
import { createPortal } from "react-dom";
import { Button } from "../Button/Button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogClose,
  DialogHeader,
  DialogProps,
} from "../Dialog/Dialog";
import { Heading } from "../Heading/Heading";
import styles from "./ConfirmDialog.module.css";

export type ConfirmDialogProps = {
  cancelLabel: string;
  confirmLabel: string;
  loading?: boolean;
  message: ReactNode | string;
  onCancel: () => void;
  onConfirm: () => void;
  subTitle?: string;
  title?: string;
} & DialogProps;

export function ConfirmDialog({
  cancelLabel,
  className,
  confirmLabel,
  loading,
  message,
  onCancel,
  onConfirm,
  subTitle,
  title,
  ...props
}: ConfirmDialogProps) {
  return createPortal(
    <Dialog
      {...props}
      className={cls(styles.ConfirmDialog, className)}
      onCancel={onCancel}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      role="alertdialog"
    >
      {title && (
        <DialogHeader>
          <Heading as="h3" subTitle={subTitle}>
            {title}
          </Heading>
        </DialogHeader>
      )}
      <DialogBody className={styles.ConfirmDialogBody}>
        {isString(message) ? <span>{message}</span> : message}
        <DialogActions className={styles.ConfirmDialogActions}>
          <DialogClose disabled={loading} onClick={onCancel} variant="outline">
            {cancelLabel}
          </DialogClose>
          <Button autoFocus loading={loading} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </DialogActions>
      </DialogBody>
    </Dialog>,
    document.body,
  );
}
